module.exports = __webpack_public_path__ + "static/media/ir.28b0fb3b.svg";